import { getByPath, setByPath } from "../../../../dot-notation/index.js";
import { produce } from "../../../../immer/index.js";
import { createProperty } from "../../utils/createProperty.js";
function resetFieldInitialValues(store, _api, mode, initialValues) {
  if (initialValues) {
    store.initialValues = produce(store.initialValues, (draft) => {
      for (const [fieldName, value] of Object.entries(initialValues)) {
        const fieldPath = fieldName;
        const fieldValue = value;
        try {
          setByPath(draft, fieldPath, fieldValue);
        } catch (e) {
          createProperty(draft, fieldPath, fieldValue);
        }
      }
    });
    store.fields = produce(store.fields, (draft) => {
      for (const [key, field] of Object.entries(draft)) {
        const fieldName = key;
        const fieldResetValue = getByPath(store.initialValues, fieldName);
        const fieldDescriptor = field;
        fieldDescriptor.resetValue = fieldResetValue;
      }
    });
  }
  if (mode === "force") {
    store.fields = produce(store.fields, (draft) => {
      for (const [key, field] of Object.entries(draft)) {
        const fieldName = key;
        const fieldValue = getByPath(store.initialValues, fieldName);
        const fieldDescriptor = field;
        fieldDescriptor.value = fieldValue;
        fieldDescriptor.status = "pristine";
      }
    });
    store.values = produce(store.values, (draft) => {
      for (const [key, field] of Object.entries(store.fields)) {
        const fieldPath = key;
        const fieldDescriptor = field;
        try {
          setByPath(draft, fieldPath, fieldDescriptor.value);
        } catch (e) {
          createProperty(draft, fieldPath, fieldDescriptor.value);
        }
      }
    });
  }
}
export {
  resetFieldInitialValues
};
//# sourceMappingURL=createCoreApi.resetFieldInitialValues.js.map
